import { lazy, useContext, useEffect } from 'react'
import { Select, TextField } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import PrinterFailIcon from '@nv/images/design/printer-fail-icon'
import { nxConfig } from '@nv/utils'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import useNVModal from '../../nv_modal/useNVModal'
import styles from './SendTestJob.module.scss'
const SendJobProgress = lazy(() => import('@nv/lazy-loadable/lib/modals/SendJobProgress'))
const NVBasicModal = lazy(() => import('@nv/lazy-loadable/lib/modals/NVBasicModal'))

const initialValues = {
  noOfPages: '',
  ballotSize: '',
}

export const SendTestJob = ({ printerToEdit, openAlertSuccessModal, setModalSuccessText }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)
  const { NVModal: SendJobProgressModal, openModal: openSendJobProgressModal, closeModal: closeSendJobProgressModal } = useNVModal()
  const { NVModal: SentJobErrorModal, openModal: openSentJobErrorModal } = useNVModal()

  const validationSchema = Yup.object().shape({
    noOfPages: Yup.number()
      .required(t('No. Of Pages'))
      .min(1, 'Must be at least 1')
      .max(1001, 'Cannot be more than 1001')
      .typeError('Must be a number'),
    ballotSize: Yup.string().required(t('Choose Ballot')),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: () => handleSendClick(),
  })

  const handleSendClick = async () => {
    openSendJobProgressModal()
    const { noOfPages, ballotSize } = formik.values
    const IPAddress = printerToEdit.IPAddress
    const finisherSerialNum = printerToEdit.finisherSerialNum
    try {
      const response = await fetch(
        `${nxConfig.PUBLIC_URL}/testing/sendTestJob?ballotSize=${ballotSize}&numCopies=${noOfPages}&socketId=${IPAddress}&finisherSerialNum=${finisherSerialNum}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            noOfPages,
            ballotSize,
            finisherSerialNum: finisherSerialNum,
          }),
        },
      )
      if (!response.ok) throw new Error('Network response was not ok')

      const data = await response.json()
      //console.log('Success:', data)
      onClose()
      closeSendJobProgressModal()
      openAlertSuccessModal()
      setModalSuccessText('job sent successfully')
    } catch (error) {
      //console.error('Error:', error)
      closeSendJobProgressModal()
      openSentJobErrorModal()
    }
  }

  useEffect(() => {
    setHeaderLabel(t('Send Test Job'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('buttons.send'), onClick: () => formik.handleSubmit() },
    ])
  }, [])

  return (
    <>
      <SendJobProgressModal>
        <SendJobProgress />
      </SendJobProgressModal>

      <SentJobErrorModal>
        <NVBasicModal
          title={'Send Test Job'}
          text={'Sending job to the printer failed. Please make sure the printer is connected and send again'}
          icon={<PrinterFailIcon />}
        />
      </SentJobErrorModal>

      <form onSubmit={formik.handleSubmit}>
        <div className={styles['container']}>
          <TextField
            formik={formik}
            type='number'
            field={'noOfPages'}
            placeholder={'No. Of Pages'}
            label={'No. Of Pages'}
            min='1'
            max='1001'
          />
          <Select
            label={t('ballot Size')}
            formik={formik}
            field='ballotSize'
            value={formik.values.ballotSize}
            options={[
              { value: 'letter', label: 'Send Letter Ballot' },
              { value: 'A4', label: 'Send A4 Ballot' },
            ]}
            isRequired={true}
          />
        </div>
      </form>
    </>
  )
}
